import { setupPreloader, setupDevUI, setupShell } from 'startup/ui-imports';
import { setupShopify, setupToast, setupPostLaunchToast } from 'startup/app-imports';
import { setupMetadata, setupRouter, setupPolyfills, setupDevice } from 'startup/load-core';
// import { setupSentryErrorTracking } from 'startup/sentry-error-tracking';
import { setupPromotion } from 'data/promotion-data'
// import { setupAssetsManager } from './startup/setup-asset-manager';
import isSandbox from 'utils/is-sandbox';
// import { setupReactivityOverride } from 'startup/reactivity-override';

const isSignIn = () => window.location.pathname === '/signin-oxefit';

const showPreloader = () => {
    return isSandbox() || isSignIn();
};

async function init() {
    // Experimental
    // setupReactivityOverride();
    // setupSentryErrorTracking();

    const preloader = showPreloader() ? null : await setupPreloader();
    // prettier-ignore
    await Promise.all([
        setupPolyfills(), 
        setupDevice(), 
        setupRouter(), 
        setupMetadata(),
        // Next version..
        // setupAssetsManager() // configure with path changes + custom loaders
    ]);

    // const toast = await setupPostLaunchToast(); // fetches countdown/clock initially.
    await setupShopify(); // had to move this to here -

    // pull current promotion
    await setupPromotion();
    
    // prettier-ignore
    await Promise.all([    
        // setupDevUI(), 
        setupShell(preloader),   
        // toast.setup(), // connects locations, reactions, etc. 
    ]);
}

export { init };
